<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            Subject: Settlement Offer Before Litigation - FCRA Compliance Request
        </p>
        <p>
            Dear {{creditBureau.name}},
        </p>
        <p class="letter-content">
            I am writing to extend a final offer to settle the matter concerning disputed entries on my credit report,
            which I believe are in violation of the Fair Credit Reporting Act (FCRA). This letter is an attempt to resolve
            these issues amicably before proceeding with litigation to seek relief and potential monetary damages as outlined
            in Sections 616 and 617 of the FCRA. Please note, this correspondence, along with my previous letters, will be submitted
            to the Federal Trade Commission as part of a formal complaint and may be used as evidence should legal action become necessary.
        </p>
        <p class="letter-content">
            Despite my three prior written requests, the credit report continues to reflect unverified items. As per the FCRA, you are obligated
            to retain and produce original documentation from the creditor to verify these entries. You have previously stated that these items
            were "verified" as "reported correctly," yet no verifier's identity has been disclosed, nor any original signed documentation provided,
            as required by Sections 609(a)(1)(A) & 611(a)(1)(A). Furthermore, the verification method has not been shared, which is a necessity under
            Section 611(a)(7). According to Section 611(5)(A) of the FCRA, any information that cannot be verified must be promptly deleted.
        </p>
        <p class="letter-content">
            I am prepared to take legal action to ensure adherence to the law and protect my rights. However, I prefer to settle this matter without court intervention.
        </p>

        <p class="letter-content">
            To that end, I request immediate verification or deletion of the following items:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            Your immediate action in this matter will be highly appreciated and will confirm your commitment to resolving consumer disputes in compliance with the FCRA.
        </p>
        <p>
            Kind Regards,
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                address,
            };
        },
    };
</script>
